// This file is automatically generated with create-ts-svgs script in package.json
import * as React from 'react'; 
			
interface ISvgProps {
	className?: string,
}
			
const fn: React.FunctionComponent<ISvgProps> = (props) => (
	<svg className={props.className} xmlns="http://www.w3.org/2000/svg" viewBox="-1926.7 -3097.8 12 9"><path fill="#262727" d="M-1926.7-3096.8v-1h12v1zm0 4v-1h12v1zm0 4v-1h12v1z"/></svg>
);

export default fn;
